import { requestEnvelope } from './client'
import { paginated, reportSchema, type Report } from './schemas'
import type { ReportFilter } from '../lib/query-keys'

export async function listReports(f: ReportFilter) {
  const params = new URLSearchParams({
    page: String(f.page),
    pageSize: String(f.pageSize),
  })
  const data = await requestEnvelope(`/reports?${params.toString()}`, paginated(reportSchema))
  return data
}

export async function getReport(id: string): Promise<Report> {
  return requestEnvelope(`/reports/${encodeURIComponent(id)}`, reportSchema)
}

export type { Report }
